import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import ClipLoader from "react-spinners/ClipLoader";

import CheckboxFilterGroup from "@areas/shared/components/filters/CheckboxFilterGroup";

import btnStyles from "@areas/shared/components/buttons/styles/button.module.css";
import styles from "./styles/filter.module.css";

function Filter({ load, data, set, values, submit }) {
  const checkDefaultOpenStyle = (values, name) => {
    return values.filter((p) => p.name === name).length > 0;
  };
  const sortByName = (a, b) =>
    (a || "").localeCompare(b || "", "ru", { sensitivity: "base" });

  const chooseFilter = (name, value) => {
    if (values.some((p) => p.name === name && p.value === value)) {
      set((p) => p.filter((item) => item.name !== name || item.value !== value));
    } else {
      set((p) => [...p, { name, value }]);
    }
  };

  const generateFilter = (data) => {
    const sortedData = [...data]
      .sort((a, b) => sortByName(a.Title, b.Title))
      .map((group) => ({
        ...group,
        Options: [...(group.Options || [])].sort((a, b) =>
          sortByName(a.Name, b.Name)
        ),
      }));

    let result = [];
    for (let i = 0; i < sortedData.length; i++) {
      switch (sortedData[i].Type) {
        case "checkboxGroup":
          result[result.length] = (
            <CheckboxFilterGroup
              key={sortedData[i].Name || i}
              styles={styles}
              name={sortedData[i].Name}
              title={sortedData[i].Title}
              options={sortedData[i].Options}
              values={values}
              defaultOpen={checkDefaultOpenStyle(values, sortedData[i].Name)}
              onChange={chooseFilter}
            />
          );
          break;
        default:
          continue;
      }
    }
    return result;
  };
  return (
    <div className={`${styles.filter}`}>
      <PerfectScrollbar
        options={{ wheelPropagation: false }}
        className={styles.inner}
      >
        {load ? (
          <div className="d-flex w-100 justify-content-center">
            <ClipLoader />
          </div>
        ) : (
          generateFilter(data)
        )}
      </PerfectScrollbar>
      {data.length > 0 && !load ? (
        <div className={styles.submit}>
          <div
            onClick={() => submit()}
            className={`${btnStyles.button} ${styles.button}`}
          >
            Применить фильтр
          </div>
        </div>
      ) : null}
      {data.length > 0 && !load ? (
        <div className={styles.clear}>
          <div
            onClick={() => {
              set([]);
              submit(undefined, true);
            }}
            className={`${btnStyles.button} ${styles.button}`}
          >
            Сбросить фильтр
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Filter;
